import PolicyPage from "./PolicyPage";

export default function Terms() {
  return (
    <PolicyPage title="Terms of service" path="/terms-of-service">
      <p>By accessing creatormicpro.com you agree to the following terms.</p>
      <h2>Purchases</h2>
      <p>All product prices are listed in USD and exclude applicable taxes. We reserve the right to refuse or cancel any order at our discretion (with a full refund).</p>
      <h2>Intellectual property</h2>
      <p>All content, product designs, logos, and photography on this site are the property of CreatorMic Pro / CLSX LLC and may not be reproduced without written permission.</p>
      <h2>Limitation of liability</h2>
      <p>CreatorMic Pro is not liable for any indirect, incidental, or consequential damages arising from the use of our products or website. Our maximum liability is limited to the amount you paid for the product in question.</p>
      <h2>Governing law</h2>
      <p>These terms are governed by the laws of the United States and the state in which CLSX LLC is registered. Any disputes will be resolved by binding arbitration.</p>
    </PolicyPage>
  );
}
